<template>
  <router-view/>
</template>
<script>
    export default {
    name: 'desacatoIndex'
    }
</script>

<style scoped>

</style>
